import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { aulaAuthHeaders } from '../aulaUserContext';
import { getVideoEmbed } from '../videoEmbed';

const ModuloDetalle = (props) => {
    const { cursoId, moduloId } = props.match.params;
    const [curso, setCurso] = useState(null);
    const [progreso, setProgreso] = useState(null);

    const cargar = useCallback(() => {
        fetch(`/aula/cursos/${cursoId}`, { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setCurso);
        fetch(`/aula/progreso/${cursoId}`, { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then(setProgreso);
    }, [cursoId]);

    useEffect(() => { cargar(); }, [cargar, moduloId]);

    const handleCompletar = () => {
        fetch(`/aula/progreso/${moduloId}/completar`, { method: 'POST', headers: aulaAuthHeaders() })
            .then(() => fetch(`/aula/progreso/${cursoId}`, { headers: aulaAuthHeaders() }))
            .then((res) => res.json())
            .then(setProgreso);
    };

    if (!curso || !progreso) return <div className="container my-4">Cargando...</div>;

    const modulos = curso.modulos;
    const indice = modulos.findIndex((m) => String(m.id) === moduloId);
    const modulo = modulos[indice];

    if (!modulo) return <div className="container my-4">Módulo no encontrado.</div>;
    if (!modulo.videos || modulo.videos.length === 0) {
        return (
            <div className="container my-4">
                <p>No tenés acceso a este módulo todavía.</p>
                <Link to={`/aula/curso/${cursoId}`}>Volver al curso</Link>
            </div>
        );
    }

    const anterior = modulos[indice - 1];
    const siguiente = modulos[indice + 1];
    const estadoModulo = progreso.modulos.find((m) => m.id === modulo.id);
    const completado = estadoModulo && estadoModulo.completado;

    return (
        <div className="container my-4">
            <Link to={`/aula/curso/${cursoId}`}>&larr; {curso.nombre}</Link>

            <h4 className="mt-3">{modulo.orden}. {modulo.titulo}</h4>

            {modulo.videos.map((video) => {
                const embed = getVideoEmbed(video.url);
                return (
                    <div key={video.id} className="mb-3">
                        {video.titulo && <h6>{video.titulo}</h6>}
                        {embed.type === 'iframe'
                            ? (
                                <div className="aula-video-embed mb-2">
                                    <iframe
                                        src={embed.src}
                                        title={video.titulo || modulo.titulo}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />
                                </div>
                            )
                            : <video controls className="aula-video mb-2" src={embed.src} />}
                    </div>
                );
            })}

            {modulo.bloques && modulo.bloques.length > 0 &&
                <div className="aula-modulo-texto mt-3">
                    {modulo.bloques.map((bloque) => <p key={bloque.id}>{bloque.texto}</p>)}
                </div>}

            {modulo.recursos && modulo.recursos.length > 0 &&
                <div className="mt-2">
                    {modulo.recursos.map((recurso) => (
                        <a key={recurso.id} className="aula-recurso-link mr-2" href={recurso.url} target="_blank" rel="noreferrer">
                            {recurso.titulo || 'Descargar material'}
                        </a>
                    ))}
                </div>}

            <div className="mt-3">
                <button className="btn aula-btn-primary" disabled={completado} onClick={handleCompletar}>
                    {completado ? 'Completado ✓' : 'Marcar como completado'}
                </button>
            </div>

            <div className="aula-modulo-nav">
                {anterior
                    ? <Link className="btn aula-btn-outline" to={`/aula/curso/${cursoId}/modulo/${anterior.id}`}>&larr; Anterior</Link>
                    : <span />}
                {siguiente
                    ? <Link className="btn aula-btn-outline" to={`/aula/curso/${cursoId}/modulo/${siguiente.id}`}>Siguiente &rarr;</Link>
                    : <Link className="btn aula-btn-primary" to={`/aula/curso/${cursoId}`}>Volver al temario</Link>}
            </div>
        </div>
    );
};

export default ModuloDetalle;
